import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="transparent" viewBox="0 0 24 24" {...props}>
    <circle
      className="circle_svg__outer"
      transform="rotate(-90 11 11)"
      cx={10}
      cy={12}
      r={11}
    />
  </svg>
);
const Memo = memo(SvgCircle);
export default Memo;
